import { useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import { websocketActionsWorkspaces } from '@/common/context/websocketActions/constants'
import useWebsocketActions from '@/common/hooks/useWebsocketActions/useWebsocketActions'
import returnsServices from '@/returns/services/services'

import { pendingWebsocketActionTypes } from '../useWebsocketTransactionAction/constants'

const useCreateExchangeOrder = ({ returnId, setToastInfo }) => {
  const [showCreateExchangeOrderDrawer, setShowCreateExchangeOrderDrawer] = useState(false)
  const [includeCancelled, setIncludeCancelled] = useState(false)
  const { setPendingWebsocketAction } = useWebsocketActions(websocketActionsWorkspaces.transactions)

  const { fetchData: createExchangeOrder, loading: creatingExchangeOrder } = useFetch(
    returnsServices.createExchangeOrder,
    {
      doInitialRequest: false,
    }
  )

  const handleCreateExchangeOrder = async includeCancelled => {
    try {
      const response = await createExchangeOrder({ returnId, payload: { include_cancelled: includeCancelled } })

      setShowCreateExchangeOrderDrawer(false)
      setPendingWebsocketAction(pendingWebsocketActionTypes.createExchangeOrder, response)
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  const openCreateExchangeOrderDrawer = () => {
    setIncludeCancelled(false)
    setShowCreateExchangeOrderDrawer(true)
  }

  const closeCreateExchangeOrderDrawer = () => {
    setShowCreateExchangeOrderDrawer(false)
  }

  return {
    showCreateExchangeOrderDrawer,
    openCreateExchangeOrderDrawer,
    closeCreateExchangeOrderDrawer,
    handleCreateExchangeOrder,
    creatingExchangeOrder,
    includeCancelled,
    setIncludeCancelled,
  }
}

export default useCreateExchangeOrder
